(function(app) {

    app.constant("qualifiedRetirementAccountTypes",
    [
        { Label: "401K", Value: "FourZeroOneK" },
        { Label: "403B", Value: "FourZeroThreeB" },
        { Label: "Pension", Value: "Pension" },
        { Label: "457B", Value: "FourFiftySevenB" },
        { Label: "Other", Value: "Other" }
    ]);

})(window.app); //jshint ignore:line